import { InjectionToken, Type } from '@angular/core';

export const STANDARD_PRODUCT_DETAIL_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('STANDARD_PRODUCT_DETAIL_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});

export const STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});
